import { Button } from '../ui/button';
import { Dialog, DialogClose, DialogContent, DialogTrigger } from '../ui/dialog';
import ArrowExpand from '@/assets/icons/arrow_expand.svg?react';
import ArrowCollapse from '@/assets/icons/arrow_collapse.svg?react';
import FullJar from '@/assets/icons/full_jar.svg?react';
import { components } from '@/types/api';

export function LoyalityRulesModal({
  account,
}: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="absolute top-0 right-0">
          <ArrowExpand />
        </Button>
      </DialogTrigger>
      <DialogContent className="h-screen min-w-full overflow-y-auto rounded-none" hideCloseButton>
        <div className="flex flex-col gap-4">
          <div className="flex justify-end">
            <DialogClose asChild>
              <Button variant="ghost" size="icon" className="absolute top-2 right-1">
                <ArrowCollapse />
              </Button>
            </DialogClose>
          </div>
          <span className="relative min-h-96">
            <span className="text-foreground text-3xl leading-normal font-bold">
              You have&nbsp;
              <br className="block md:hidden" />
              earned
              <br />
              <span className="text-primary">{account.loyalty_earned} points</span>
            </span>
            <FullJar className="absolute top-0 -right-6" />
          </span>
          <div className="flex flex-col gap-4">
            <p className="text-foreground text-base leading-normal font-bold">
              Snap receipt images while earning loyalty points. You get a $5 gift card once you
              gather 1000 points. Be part of our journey by providing us with real receipts.
            </p>
            <p className="text-foreground text-base leading-normal font-bold">
              How you can earn more points:
            </p>
            <ul className="list-inside pl-2">
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                200 points for signing up
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                100 points per receipt
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                20 points for every receipt that you send for review and is accepted
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                100 points for each successful referral. You win when they upload the first receipt
              </li>
            </ul>
            <p className="text-foreground text-base leading-normal font-bold">
              Upon accumulating the first 1000 points, you will receive a $5 digital gift card via
              email. Thereafter, each time you hit a points tier you will receive a digital gift
              card with the redeemable value.
            </p>
            <ul className="list-inside pl-2">
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                First 1000 points: $5
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Next 1500 points: $5
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Next 2000 points: $5
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Next 2500 points: $5
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Next 3000 points: $5
              </li>
            </ul>
            <p className="text-foreground text-base leading-normal font-bold">Receipts uploaded:</p>
            <ul className="list-inside pl-2">
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Must be in English
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Must be genuine and legible
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Must include the retailer's name, items purchased, prices, total amount paid, and
                transaction date
              </li>
              <li className="text-foreground border-b border-[#f2f2f2] py-2 text-xs leading-normal font-normal">
                Must not be a duplicate
              </li>
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
